import { render, staticRenderFns } from "./EditPreferencesThird.vue?vue&type=template&id=383b49fd&scoped=true&"
import script from "./EditPreferencesThird.vue?vue&type=script&lang=js&"
export * from "./EditPreferencesThird.vue?vue&type=script&lang=js&"
import style0 from "./EditPreferencesThird.vue?vue&type=style&index=0&id=383b49fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b49fd",
  null
  
)

export default component.exports